import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons/faMinus";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";

import { colors } from "utils/styles";
import { CartContext } from "contexts/";

export default function QuantityInput(props) {
	const deleteTimerTime = 5;
	const { localCart, setLocalCart } = useContext(CartContext);

	const { item, removeItem } = props;

	//only books can have more thn 1 quantity
	const notBook = item.productType !== "Book";

	const validateQuantity = (item) => {
		//only books can be more than 1
		if (notBook && item.quantity > 1) {
			item.quantity = 1;
		}
		//dont allow less than 0
		if (item.quantity <= 0) item.quantity = 1;

		return item;
	};

	const increaseQty = () => {
		setLocalCart((localCart) => {
			let cartItem = localCart[item.variantId];
			cartItem.quantity = parseInt(cartItem.quantity) + 1;
			//validate cartItem quantity
			cartItem = validateQuantity(cartItem);
			localCart[cartItem.variantId] = cartItem;
			return { ...localCart };
		});
	};

	const decreaseQty = () => {
		setLocalCart((localCart) => {
			let cartItem = localCart[item.variantId];
			cartItem.quantity -= 1;
			//validate cartItem quantity
			cartItem = validateQuantity(cartItem);
			localCart[cartItem.variantId] = cartItem;
			return { ...localCart };
		});
	};

	const disableDecrement = item.quantity == 1;
	const disableIncrement = notBook;

	return (
		<div className="quantity-container">
			{/* <button disabled={notBook && item.quantity != 1} onClick={() => decreaseQty()} className=" minus-qty"> */}
			<button
				title={disableDecrement ? `Use the delete button to remove (red X)` : "Decrement Quantity"}
				disabled={disableDecrement}
				onClick={() => decreaseQty()}
				className={` ${disableDecrement ? "btn-disable" : ""}  minus-qty`}
			>
				<FontAwesomeIcon className="icon" icon={faMinus} />
			</button>

			<input
				type="number"
				value={item.quantity}
				onChange={(e) => {
					setLocalCart((localCart) => {
						let cartItem = localCart[item.variantId];

						//set the values
						cartItem.quantity = parseInt(e.target.value);
						//validate cartItem quantity
						cartItem = validateQuantity(cartItem);
						//update local cart
						localCart[cartItem.variantId] = cartItem;
						// return new localCart state
						return { ...localCart };
					});
				}}
			/>
			<button
				title={disableIncrement ? `Limited to one ${item.title}` : "Increment Quantity"}
				disabled={disableIncrement}
				onClick={() => increaseQty()}
				className={`${disableIncrement ? "btn-disable" : ""} plus-qty`}
			>
				<FontAwesomeIcon className="icon" icon={faPlus} />
			</button>
			{/* {aboutToDelete && (
				<div className="deleteTimer">
					<div className="progress">
						<div className="timer"></div>
						<div className="absolute">DELETING in {timeToDelete.toFixed(1)}</div>
					</div>
				</div>
			)} */}
			<style jsx>{`
				.deleteTimer {
					position: absolute;
					width: 100%;
					bottom: -1.3em;
				}
				.timer {
					background-color: yellow;
					animation: removeItemAnimation ${deleteTimerTime}s linear;
				}
				.plus-qty {
					border-radius: 0px 20px 20px 0px;
					display: flex;
					align-items: center;
					height: 100%;
					flex-direction: row;
				}

				.minus-qty {
					border-radius: 20px 0px 0px 20px;
					display: flex;
					align-items: center;
					height: 100%;
					flex-direction: row;
				}
				.quantity-container {
					display: flex;
					justify-content: center;
					flex-direction: row;
					height: 2em;
					align-items: center;
					position: relative;
				}

				button {
					transition: all 0.2s;
					border: 1px solid ${colors.black};
				}
				button:hover {
					filter: brightness(110%);
				}
				input {
					border: 1px solid ${colors.black};
					text-align: center;
					height: 2em;
					background: inherit;
					font-weight: bold;
					width: 3em;
					padding: 0;
					border-radius: 0px;
					display: flex;
					justify-content: center;
				}

				.btn-disable {
					border: 1px solid ${colors.greyBlue};
				}

				@media screen and (max-width: 768px) {
					input {
						width: 2em;
					}
					input::-webkit-outer-spin-button,
					input::-webkit-inner-spin-button {
						/* display: none; <- Crashes Chrome on hover */
						-webkit-appearance: none;
						margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
					}

					input[type="number"] {
						-moz-appearance: textfield; /* Firefox */
					}

					.plus-qty {
						font-size: 5px;
					}

					.minus-qty {
						font-size: 5px;
					}
				}
			`}</style>
		</div>
	);
}
